export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/ReplacementOrderModal/components/ReplacementOrderTable";
